import Keyed from "../IKeyed";

export interface ICustomerReference extends Keyed {
  id: string;
  customerId: string;
  name: string;
  address: string;
  city: string;
  stateId?: string;
  zip: string;
  homePhone: string;
  cellPhone: string;
  callable: boolean;
  emailAddress: string;
  isVerified: boolean; // whether or not the reference is verified
  livesWith: boolean; // whether or not the reference lives with the customer
  customerReferenceRelationshipId: string;
  createdBy: string;
  createdDate: Date;
  modifiedBy: string;
  modifiedDate: Date;
  note: string;
  sentToAmsDate?: Date;
  sentToAmsById?: string;
}

export const buildDefaultCustomerReference = (id: string, customerId: string, modifiedById: string): ICustomerReference => {
  return {
    id: id,
    customerId: customerId,
    isVerified: false,
    livesWith: false,
    cellPhone: '',
    homePhone: '',
    customerReferenceRelationshipId: '',
    address: '',
    name: '',
    createdBy: modifiedById,
    createdDate: new Date(),
    modifiedBy: modifiedById,
    modifiedDate: new Date(),
    note: '',
    callable: true,
    city: '',
    emailAddress: '',
    zip: ''
  }
};